/**
 * Tunable sim constants (GDD-SHARED baselines).
 * Tones must not fork these without a schema/API version bump.
 */
/** Fixed simulation tick rate (Hz). Render interpolates at display rate. */
export const TICK_HZ = 20;
export const TICK_DT = 1 / TICK_HZ;
/** Soft cap: full formation remains readable. */
export const SOFT_CAP = 100;
/** Hard cap: sim/render ceiling; excess becomes power tokens. */
export const HARD_CAP = 250;
/** Exact count display through this value; above → compact formatting. */
export const DISPLAY_EXACT_MAX = 99;
/** Default unit DPS (aggregate model B: total = N * UNIT_DPS). */
export const UNIT_DPS = 4;
/** Default HP per friendly unit (for damage-in / loss of N). */
export const UNIT_HP = 10;
/** Formation: Archimedean spiral parameters (world units). */
export const SPIRAL_A = 0.35;
export const SPIRAL_B = 0.22;
export const SPIRAL_ANGLE_STEP = 0.65;
/** Mecha transform baselines (consume-all scaling). */
export const MECHA_HP_BASE = 500;
export const MECHA_HP_LINEAR = 40;
export const MECHA_HP_POWER_COEF = 2;
export const MECHA_HP_POWER_EXP = 1.1;
export const MECHA_DPS_BASE = 80;
export const MECHA_DPS_PER_UNIT = 8;
/** Path / steer defaults. */
export const PATH_HALF_WIDTH = 3.5;
export const FORWARD_SPEED = 6;
export const LATERAL_SPEED = 10;
/** Package identity. */
export const PACKAGE_NAME = "@afr/sim";
export const PACKAGE_VERSION = "0.1.0";
export const SIM_API_VERSION = 1;
//# sourceMappingURL=constants.js.map